import { ProjectId } from 'api/models';
import { ProjectUsersLiteQueryKey } from 'api/project';

export type ProjectTasksQueryKey = [string, number];
export const getProjectTasksQueryKey = ([
  ,
  projectId,
]: ProjectId): ProjectTasksQueryKey => ['tasks', projectId];
export const getProjectDetailQueryKey = (projectId: ProjectId): ProjectId =>
  projectId;

export const getProjectUsersLiteKey = (
  projectId?: number,
): ProjectUsersLiteQueryKey => [
  'project-users-lite',
  `${projectId?.toString() ?? 'all'}`,
];

export const getProjectDependencyMapKey = (projectId) => [
  'project-dependency-map',
  `${projectId.toString()}`,
];
